import validate from "/app/node_modules/.pnpm/nuxt@3.21.7_@parcel+watcher@2.5.6_@types+node@24.12.4_@vue+compiler-sfc@3.5.35_cac@6.7._07bfedff0c1c82e81e14dd9d7a28cad8/node_modules/nuxt/dist/pages/runtime/validate.js";
import compat_45routing_45global from "/app/middleware/compat-routing.global.ts";
import i18n_45prefix_45global from "/app/middleware/i18n-prefix.global.ts";
import manifest_45route_45rule from "/app/node_modules/.pnpm/nuxt@3.21.7_@parcel+watcher@2.5.6_@types+node@24.12.4_@vue+compiler-sfc@3.5.35_cac@6.7._07bfedff0c1c82e81e14dd9d7a28cad8/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  compat_45routing_45global,
  i18n_45prefix_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}